import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Shell } from "@/components/Shell";
import { SummaryCards } from "@/components/SummaryCards";
import { PositionCards } from "@/components/PositionCards";
import { OrderCards } from "@/components/OrderCards";
import { BlockedBanner } from "@/components/BlockedBanner";
import { ProfileDrawer } from "@/components/ProfileDrawer";
import { useDesk } from "@/hooks/useDesk";

export default function Positions() {
  const desk = useDesk();
  const { state } = useLocation();
  const [profile, setProfile] = useState(false);
  const [highlight, setHighlight] = useState(state?.highlight ?? null);
  const timer = useRef(null);

  useEffect(() => {
    if (!state?.highlight) return;
    setHighlight(state.highlight);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setHighlight(null), 3000);
    window.history.replaceState({}, "");
    return () => clearTimeout(timer.current);
  }, [state?.highlight]);

  return (
    <Shell status={desk.status} onProfile={() => setProfile(true)}>
      <div className="flex flex-col gap-5">
        <div>
          <h1 className="text-2xl sm:text-3xl font-heading font-bold tracking-tight text-zinc-50">
            Positions
          </h1>
          <p className="text-xs text-zinc-300 font-mono mt-1">
            {desk.summary?.server_time_ist ? `${desk.summary.server_time_ist} IST` : "—"} · Balance $
            {desk.summary?.account?.balance?.toFixed(2) ?? "0.00"} · Equity $
            {desk.summary?.account?.equity?.toFixed(2) ?? "0.00"}
          </p>
        </div>

        <BlockedBanner blocked={desk.blocked} />
        <SummaryCards summary={desk.summary} collapsible storageKey="positions-summary-open" />

        <PositionCards
          positions={desk.positions}
          onRefresh={desk.kick}
          onPatch={desk.patchPosition}
          onDrop={desk.dropPosition}
          refreshing={desk.refreshing}
          updatedAt={desk.updatedAt}
          live={desk.live}
          highlightTicket={highlight}
        />

        <OrderCards
          orders={desk.orders}
          onChange={desk.kick}
          onDrop={desk.dropOrder}
          highlightTicket={highlight}
        />
      </div>

      <ProfileDrawer
        open={profile}
        onClose={() => setProfile(false)}
        status={desk.status}
        settings={desk.settings}
        summary={desk.summary}
        onChange={() => {
          desk.kick();
          desk.loadStatic();
        }}
      />
    </Shell>
  );
}
